// Import the zustand store instance
import useQuoteStore from "../store/QuoteStore";
import Claim from "../../../shared/models/claimModel";
import { formatDateT } from "../../../shared/utils/formatters";

const TqClaimMapper = {
  get() {
    return useQuoteStore.getState().quote?.risk?.drivers[0]?.claims || [];
  },

  set(data) {
    const { updateField } = useQuoteStore.getState();
    const existingClaims = this.get();

    // Create new claim instance
    const newClaim = new Claim(
      data.claimType?.value,
      formatDateT(data.AddClaim_Date),
      Number(data.claimCost),
      data.WhosFault === "Yes",
      data.Injured === "Yes",
      null, // objectId
      null, // claimDetailsId
      false, // theftFromHome
      null, // statusId
      false, // ncdAffected
      false, // incurredOnPolicy
      null, // referenceNumber
      null, // parentObjectId
      0 // parentObjectHistoryId
    );

    let updatedClaims;
    if (data.index !== null && data.index !== undefined) {
      // Update existing claim at index
      updatedClaims = [...existingClaims];
      updatedClaims[data.index] = newClaim;
    } else {
      // Add new claim
      updatedClaims = [...existingClaims, newClaim];
    }

    // Update the store
    updateField("risk.drivers.0.claims", updatedClaims);
  },

  delete(index) {
    const { updateField } = useQuoteStore.getState();
    const existingClaims = this.get();
    const updatedClaims = existingClaims.filter((_, i) => i !== index);
    updateField("risk.drivers.0.claims", updatedClaims);
  },
};

export default TqClaimMapper;
